<mat-card *ngIf="errors" class="bg-error mat-elevation-z0">
  <mat-card-content>
    <h5 class="text-base">Error</h5>
    <ul style="list-style-type: square">
      <li *ngFor="let message of messages">{{ message }}</li>
    </ul>
  </mat-card-content>
</mat-card>
